/*
 * sr-cart-ctrl-v1.1.js — 购物车 Controller 层（MVC 架构 v1.2）
 * 最后修改: 2026-08-03 v1.1
 *
 * v1.3 命名规范 v1.0 适配：
 *   - latestData → memberData（SRController.get() 返回值统一命名）
 *   - globalEmail → prevEmail（消除旧 global 命名残留）
 *   - snapshotEmail → prevEmail（回调参数统一）
 *   - previousEmail → fallbackEmail（语义更清晰）
 *   - ctrl_syncCustomerFromController: 字段名一致后用 Object.assign 简化
 *
 * v1.1 最小改动（配合 Controller v1.9 + QuickPay v8.1）：
 *   - handleDrawerClose 非注册路径: setEmail 加 writeToLocalStorage: true
 *   - _handleEmailResolution confirm 路径: close 前先 cart.save 更新 sandbox
 *
 * 职责：所有数据操作（Ctrl 层 — 指挥官）
 *   - 购买域管理（srPurchaseCustomer / srPurchaseProducts）
 *   - Coupon 管理（含 coupon_type 追踪）
 *   - 地址簿数据层（localStorage）
 *   - 抽屉关闭统一流程（lookup → 两步确认 → 折扣 Cookie 清除）
 *   - 折扣计算（纯函数，含 couponType）
 *   - 初始化（新会话检测、清除残留购物车）
 *
 * 原则：
 *   - Ctrl 管判断/时序/调度，通过 SRModel API 操作数据
 *   - 关抽屉时主动清除 Shopify 折扣 Cookie（约束10）
 *   - email 变更走 lookup → 确认 → 注册 两步流程
 *
 * 依赖：SRController v1.2（必须先加载）
 * 被依赖：sr-quick-pay-v6.0.js（View 层）
 *
 * 对外 API：window.SRCartCtrl
 */

(function() {
  'use strict';

  // ============================================================
  // 常量
  // ============================================================

  var PAYPAL_EMAIL = 'zhangchi331@163.com';
  var WORKER_URL = 'https://workerapi.sandalwoodritual.com';
  var INSIDER_DISCOUNT_RATE = 0.10;

  // ============================================================
  // 状态变量
  // ============================================================

  // 购买域
  var srPurchaseCustomer = null;
  var srPurchaseProducts = null;

  // Coupon
  var _lastCouponCode = '';
  var _lastCouponRate = 0;
  var _lastCouponType = ''; // 'member' | 'coupon' | 'both' | ''

  // 地址簿
  var ADDRESSES_KEY = 'sr_shipping_addresses';
  var DEFAULT_ADDR_KEY = 'sr_default_address_idx';

  // Coupon 持久化（防止刷新后从 Shopify cart 恢复脏折扣码如 SRTEST50）
  var COUPON_KEY = 'sr_coupon_code';

  // ============================================================
  // 前置检查
  // ============================================================

  if (typeof SRController === 'undefined') {
    console.error('[SRCartCtrl] SRController not found. sr-controller.js must load first.');
    return;
  }

  // ============================================================
  // 工具函数
  // ============================================================

  function f_isValidEmail(e) {
    return e && e.indexOf('@') > 0 && e.lastIndexOf('@') < e.length - 1;
  }

  function f_formatPrice(cents) {
    return (cents / 100).toFixed(2);
  }

  function f_getCartData() {
    return fetch('/cart.js').then(function(r) { return r.json(); });
  }

  // ============================================================
  // 购买域管理
  // ============================================================

  function ctrl_getCustomer() {
    return srPurchaseCustomer;
  }

  function ctrl_getProducts() {
    return srPurchaseProducts;
  }

  function ctrl_createPurchaseDomain(cart) {
    var memberData = SRController.get();
    srPurchaseCustomer = {
      mid: memberData.mid || '',
      email: memberData.email || '',
      originalEmail: memberData.email || '',
      first_name: memberData.first_name || '',
      last_name: memberData.last_name || '',
      phone: memberData.phone || ''
    };

    srPurchaseProducts = [];
    if (cart && cart.items) {
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        srPurchaseProducts.push({
          variantId: item.variant_id,
          title: item.title,
          variantTitle: item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '',
          unitPrice: item.original_price || item.price,
          quantity: item.quantity
        });
      }
    }

    console.log('[SRCartCtrl] Purchase domain: ' + srPurchaseProducts.length + ' items');
  }

  function ctrl_syncCustomerFromController() {
    if (!srPurchaseCustomer) return;
    var memberData = SRController.get();
    // 命名统一后，字段名一致，直接引用传递
    Object.assign(srPurchaseCustomer, {
      mid: memberData.mid || srPurchaseCustomer.mid,
      email: memberData.email || srPurchaseCustomer.email,
      first_name: memberData.first_name || srPurchaseCustomer.first_name,
      last_name: memberData.last_name || srPurchaseCustomer.last_name,
      phone: memberData.phone || srPurchaseCustomer.phone
    });
  }

  function ctrl_syncProductsFromCart(cart) {
    if (!cart || !cart.items) return;

    var existingMap = {};
    if (srPurchaseProducts) {
      for (var i = 0; i < srPurchaseProducts.length; i++) {
        existingMap[srPurchaseProducts[i].variantId] = srPurchaseProducts[i];
      }
    }

    srPurchaseProducts = [];
    for (var j = 0; j < cart.items.length; j++) {
      var item = cart.items[j];
      var existing = existingMap[item.variant_id];
      srPurchaseProducts.push({
        variantId: item.variant_id,
        title: item.title,
        variantTitle: item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '',
        unitPrice: existing ? existing.unitPrice : (item.original_price || item.price),
        quantity: item.quantity
      });
    }
  }

  function ctrl_updateCustomer(data) {
    if (!srPurchaseCustomer) return;
    for (var key in data) {
      if (data.hasOwnProperty(key) && key in srPurchaseCustomer) {
        srPurchaseCustomer[key] = data[key];
      }
    }
  }

  // ============================================================
  // Coupon 管理
  // ============================================================

  function ctrl_getCoupon() {
    return { code: _lastCouponCode, rate: _lastCouponRate, type: _lastCouponType };
  }

  function ctrl_applyCoupon(code) {
    if (!code) return Promise.resolve({ valid: false, rate: 0, error: 'Empty code' });
    return fetch('/discount/' + encodeURIComponent(code), {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow'
    }).then(function(resp) {
      if (resp.status >= 400) return { valid: false, rate: 0, error: 'Invalid code' };
      return fetch('/cart.js', { credentials: 'same-origin' }).then(function(r) { return r.json(); });
    }).then(function(cart) {
      if (!cart || !cart.items || cart.items.length === 0) return { valid: false, rate: 0, error: 'Empty cart' };
      var updates = {};
      for (var i = 0; i < cart.items.length; i++) {
        updates[cart.items[i].key] = cart.items[i].quantity;
      }
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates: updates })
      }).then(function(r) { return r.json(); }).then(function(updatedCart) {
        var discountApplied = false;
        var couponRate = 0;
        if (updatedCart.discount_codes && updatedCart.discount_codes.length > 0) {
          for (var i = 0; i < updatedCart.discount_codes.length; i++) {
            var dc = updatedCart.discount_codes[i];
            if (dc.code.toUpperCase() === code.toUpperCase() && dc.applicable === true) {
              discountApplied = true;
              if (updatedCart.original_total_price > 0) {
                couponRate = updatedCart.total_discount / updatedCart.original_total_price;
              }
              break;
            }
          }
        }
        if (discountApplied) {
          _lastCouponCode = code;
          _lastCouponRate = couponRate;
          _lastCouponType = 'coupon';
          try { localStorage.setItem(COUPON_KEY, code); } catch(e) {}
          return { valid: true, rate: couponRate, error: '' };
        }
        return { valid: false, rate: 0, error: 'Coupon "' + code + '" not applicable' };
      });
    }).catch(function() {
      return { valid: false, rate: 0, error: 'Network error' };
    });
  }

  function ctrl_removeCoupon() {
    try { localStorage.removeItem(COUPON_KEY); } catch(e) {}
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount_codes: [] })
    }).then(function() {
      _lastCouponCode = '';
      _lastCouponRate = 0;
      _lastCouponType = '';
      return true;
    }).catch(function() {
      _lastCouponCode = '';
      _lastCouponRate = 0;
      _lastCouponType = '';
      return true;
    });
  }

  function ctrl_restoreCouponFromCart(cart) {
    if (!cart || !cart.discount_codes || cart.discount_codes.length === 0) return;
    for (var i = 0; i < cart.discount_codes.length; i++) {
      var dc = cart.discount_codes[i];
      if (dc.applicable === true) {
        _lastCouponCode = dc.code;
        if (cart.original_total_price > 0 && cart.total_discount > 0) {
          _lastCouponRate = cart.total_discount / cart.original_total_price;
        }
        _lastCouponType = 'coupon';
        console.log('[SRCartCtrl] Restored coupon from cart:', _lastCouponCode, 'rate:', _lastCouponRate);
        break;
      }
    }
  }

  function ctrl_clearCoupon() {
    _lastCouponCode = '';
    _lastCouponRate = 0;
    _lastCouponType = '';
    try { localStorage.removeItem(COUPON_KEY); } catch(e) {}
  }

  // ============================================================
  // 地址簿数据层（localStorage）
  // ============================================================

  function ctrl_getAddresses() {
    try {
      var raw = localStorage.getItem(ADDRESSES_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  }

  function ctrl_saveAddresses(addrs) {
    localStorage.setItem(ADDRESSES_KEY, JSON.stringify(addrs));
  }

  function ctrl_getDefaultIdx() {
    try { return parseInt(localStorage.getItem(DEFAULT_ADDR_KEY)) || 0; }
    catch (e) { return 0; }
  }

  function ctrl_setDefaultIdx(idx) {
    localStorage.setItem(DEFAULT_ADDR_KEY, String(idx));
  }

  function ctrl_getSavedAddress() {
    var addrs = ctrl_getAddresses();
    var idx = ctrl_getDefaultIdx();
    return addrs[idx] || null;
  }

  function ctrl_getShippingFields() {
    var addr = ctrl_getSavedAddress();
    if (!addr) return [];
    return [
      { name: 'address_override', value: '1' },
      { name: 'first_name', value: addr.first_name },
      { name: 'last_name', value: addr.last_name },
      { name: 'address1', value: addr.address1 },
      { name: 'address2', value: addr.address2 || '' },
      { name: 'city', value: addr.city },
      { name: 'state', value: addr.state },
      { name: 'zip', value: addr.zip },
      { name: 'country', value: addr.country || 'US' },
      { name: 'phone', value: addr.phone || '' }
    ];
  }

  // ============================================================
  // 折扣计算（纯函数）
  // ============================================================

  function ctrl_calculateDiscount(isMember, couponRate) {
    var memberRate = isMember ? INSIDER_DISCOUNT_RATE : 0;
    var cRate = couponRate || 0;
    var couponType = '';

    if (cRate > 0 && memberRate > 0) {
      var discountRate = 1 - (1 - cRate) * (1 - memberRate);
      couponType = 'both';
      return {
        discountRate: discountRate,
        formula: 'Insider 10% + Coupon ' + Math.round(cRate * 100) + '% = ' + Math.round(discountRate * 100) + '% off',
        couponRate: cRate,
        memberRate: memberRate,
        couponType: couponType
      };
    } else if (memberRate > 0) {
      couponType = cRate > 0 ? 'both' : 'member';
      return { discountRate: memberRate, formula: 'Insider 10% off', couponRate: 0, memberRate: memberRate, couponType: couponType };
    } else if (cRate > 0) {
      couponType = 'coupon';
      return { discountRate: cRate, formula: 'Coupon ' + Math.round(cRate * 100) + '% off', couponRate: cRate, memberRate: 0, couponType: couponType };
    }
    return { discountRate: 0, formula: '', couponRate: 0, memberRate: 0, couponType: '' };
  }

  function ctrl_applyDiscountToProducts() {
    if (!srPurchaseProducts || srPurchaseProducts.length === 0) return null;

    var dr = ctrl_calculateDiscount(SRController.isMember(), _lastCouponRate);
    var originalTotal = 0;
    var finalTotal = 0;
    var items = [];

    for (var i = 0; i < srPurchaseProducts.length; i++) {
      var p = srPurchaseProducts[i];
      var lineOriginal = p.unitPrice * p.quantity;
      var lineFinal = Math.round(p.unitPrice * (1 - dr.discountRate)) * p.quantity;
      originalTotal += lineOriginal;
      finalTotal += lineFinal;
      items.push({
        variantId: p.variantId,
        title: p.title,
        variantTitle: p.variantTitle,
        unitPrice: p.unitPrice,
        quantity: p.quantity,
        unitFinalPrice: Math.round(p.unitPrice * (1 - dr.discountRate)),
        lineOriginal: lineOriginal,
        lineFinal: lineFinal
      });
    }

    return {
      items: items,
      originalTotal: originalTotal,
      finalTotal: finalTotal,
      discountResult: dr
    };
  }

  // ============================================================
  // 注册 / 迁移（Worker 通信）
  // ============================================================

  function ctrl_autoRegister(email) {
    console.log('[SRCartCtrl] Auto-registering via SRController.processEmailInput: ' + email);
    return SRController.processEmailInput(email).then(function(data) {
      if (data && data.mid) {
        ctrl_syncCustomerFromController();
        return true;
      }
      return false;
    }).catch(function(err) {
      console.error('[SRCartCtrl] autoRegister error:', err);
      return false;
    });
  }

  function ctrl_migrateEmail(mid, newEmail) {
    if (!mid) return Promise.reject(new Error('No mid for migration'));
    return new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', WORKER_URL + '/api/member/migrate-email');
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            var resp = JSON.parse(xhr.responseText);
            if (resp.success) { resolve(resp); return; }
          } catch (e) {}
        }
        reject(new Error('Email migration failed'));
      };
      xhr.onerror = function() { reject(new Error('Network error')); };
      xhr.send(JSON.stringify({ mid: mid, new_email: newEmail }));
    });
  }

  // ============================================================
  // 抽屉关闭统一流程（核心修复）
  // ============================================================

  /**
   * handleDrawerClose — 关抽屉时的完整流程（v2.0 简化版）
   *
   * 流程：
   *   1. 从 DOM 读取当前 email/phone → 同步到沙盒
   *   2. 清除 Shopify 折扣 Cookie（约束10）
   *   3. 关闭抽屉（邮箱验证由 Controller.cart.close() 统一处理）
   *
   * v2.0: 去掉lookup判断，所有邮箱变更走Controller.processEmailInput
   *
   * @param {Object} opts
   * @param {Function} opts.onEmailChanged - function(prevEmail, newEmail, existingMember) → Promise<string|false>
   * @returns {Promise}
   */
  function ctrl_handleDrawerClose(opts) {
    opts = opts || {};

    // Step 1: 从 DOM 读取 email/phone，同步到沙盒
    var emailInput = document.getElementById('sr_addr_email');
    if (emailInput) {
      var drawerEmail = emailInput.value.trim().toLowerCase();
      if (f_isValidEmail(drawerEmail)) {
        SRController.cart.save({ email: drawerEmail });
      }
    }
    var phoneInput = document.getElementById('sr_addr_phone');
    if (phoneInput) {
      var drawerPhone = phoneInput.value.trim();
      if (drawerPhone) {
        SRController.cart.save({ phone: drawerPhone });
      }
    }

    // Step 2: 记录当前email用于返回
    var memberData = SRController.get();
    var prevEmail = (memberData.email || '').toLowerCase();

    // Step 3: 直接关闭抽屉，邮箱验证交给cart.close()统一处理（Controller v2.0+）
    return _closeAndClear(prevEmail);
  }

  /**
   * 关闭抽屉 + 清除 Shopify 折扣 Cookie（约束10）
   */
  function _closeAndClear(fallbackEmail) {
    // 清除 Shopify 折扣 Cookie
    var clearPromise = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount_codes: [] })
    }).catch(function() { /* 忽略清除失败 */ });

    return clearPromise.then(function() {
      var closePromise = SRController.cart.close();
      if (!closePromise || typeof closePromise.then !== 'function') {
        closePromise = Promise.resolve();
      }
      return closePromise;
    }).then(function() {
      var memberData = SRController.get();
      console.log('[SRCartCtrl] Drawer closed:', JSON.stringify({
        mid: memberData.mid,
        email: memberData.email,
        isMember: SRController.isMember()
      }));
      return memberData.email || fallbackEmail || '';
    });
  }

  function _handleEmailResolution(prevEmail, sandboxEmail, resolvedEmail) {
    // 用户选了 false / 取消 / 原 email → 回退：把沙盒 email 改回原值，再关闭
    if (!resolvedEmail || resolvedEmail === false || resolvedEmail === prevEmail) {
      SRController.cart.save({ email: prevEmail });
      return SRController.cart.close().then(function() {
        // 恢复 DOM 中的 email 输入框
        var emailInput = document.getElementById('sr_addr_email');
        if (emailInput) emailInput.value = prevEmail;
        return prevEmail;
      });
    }
    // 用户选了新 email → 先更新 sandbox email，再 close
    // v1.1: 防止 close() 的 "email changed without Confirm" 检查再次触发 setEmail
    if (resolvedEmail === sandboxEmail) {
      SRController.cart.save({ email: resolvedEmail });
      return SRController.cart.close().then(function() {
        return sandboxEmail;
      });
    }
    // 其他情况（理论上不该走到）
    return SRController.cart.close().then(function() {
      return resolvedEmail || prevEmail;
    });
  }

  function _syncEmailDirectly(prevEmail, sandboxEmail) {
    // 没有回调时直接提交新 email（沙盒保持不变，close() 会自动调 setEmail）
    return SRController.cart.close().then(function() {
      return sandboxEmail;
    });
  }

  // ============================================================
  // 初始化
  // ============================================================

  function ctrl_init() {
    // 等待 SRController 就绪
    var ctrlReady = Promise.resolve();
    if (typeof SRController !== 'undefined' && typeof SRController.init === 'function') {
      ctrlReady = SRController.init() || Promise.resolve();
    }

    // 新会话检测：清除残留的 Shopify 购物车和折扣码
    // 修复：必须先完成 clear，再加载购物车数据（否则竞态导致旧数据被恢复）
    var isNewSession = !sessionStorage.getItem('sr_session_active');
    if (isNewSession) {
      sessionStorage.setItem('sr_session_active', '1');

      return ctrlReady.then(function() {
        // Step 1: 清空购物车
        return fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin'
        });
      }).then(function() {
        // Step 2: 清除折扣码
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ discount_codes: [] })
        });
      }).then(function() {
        _lastCouponCode = '';
        _lastCouponRate = 0;
        try { localStorage.removeItem(COUPON_KEY); } catch(e) {}
        console.log('[SRCartCtrl] New session: cart and discount codes cleared');
        // Step 3: 清空完成后再加载（此时购物车应该是空的）
        return f_getCartData();
      }).then(function(cart) {
        ctrl_createPurchaseDomain(cart);
        // 新会话不恢复 coupon（clear 已经清掉了）
      }).catch(function(err) {
        console.warn('[SRCartCtrl] New session clear error:', err);
        // 降级：即使 clear 失败也加载当前购物车（不再从 Shopify cart 恢复脏折扣码）
        return f_getCartData().then(function(cart) {
          ctrl_createPurchaseDomain(cart);
        });
      });
    }

    // 非新会话：清除 Shopify 购物车残留折扣码，防止 SRTEST50 等脏码刷新后复活
    return ctrlReady.then(function() {
      // 先清除 Shopify 购物车中的折扣码
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ discount_codes: [] })
      }).catch(function() {}).then(function() {
        return f_getCartData();
      });
    }).then(function(cart) {
      ctrl_createPurchaseDomain(cart);
      // 从 localStorage 恢复用户之前输入的 coupon（而非从 Shopify cart 恢复）
      var savedCoupon = '';
      try { savedCoupon = localStorage.getItem(COUPON_KEY) || ''; } catch(e) {}
      if (savedCoupon && cart.items && cart.items.length > 0) {
        ctrl_applyCoupon(savedCoupon).then(function(result) {
          if (result.valid) {
            console.log('[SRCartCtrl] Restored coupon from localStorage:', savedCoupon);
          } else {
            console.warn('[SRCartCtrl] Saved coupon restore failed:', savedCoupon, result.error);
            try { localStorage.removeItem(COUPON_KEY); } catch(e) {}
          }
        });
      }
    }).catch(function() {
      ctrl_createPurchaseDomain({ items: [] });
    });
  }

  // ============================================================
  // 对外暴露
  // ============================================================

  window.SRCartCtrl = {
    // 购买域
    getCustomer: ctrl_getCustomer,
    getProducts: ctrl_getProducts,
    createPurchaseDomain: ctrl_createPurchaseDomain,
    syncCustomerFromController: ctrl_syncCustomerFromController,
    syncProductsFromCart: ctrl_syncProductsFromCart,
    updateCustomer: ctrl_updateCustomer,

    // Coupon
    getCoupon: ctrl_getCoupon,
    applyCoupon: ctrl_applyCoupon,
    removeCoupon: ctrl_removeCoupon,
    restoreCouponFromCart: ctrl_restoreCouponFromCart,
    clearCoupon: ctrl_clearCoupon,

    // 地址簿
    getAddresses: ctrl_getAddresses,
    saveAddresses: ctrl_saveAddresses,
    getDefaultIdx: ctrl_getDefaultIdx,
    setDefaultIdx: ctrl_setDefaultIdx,
    getSavedAddress: ctrl_getSavedAddress,
    getShippingFields: ctrl_getShippingFields,

    // 折扣
    calculateDiscount: ctrl_calculateDiscount,
    applyDiscountToProducts: ctrl_applyDiscountToProducts,

    // 注册/迁移
    autoRegister: ctrl_autoRegister,
    migrateEmail: ctrl_migrateEmail,

    // 抽屉关闭
    handleDrawerClose: ctrl_handleDrawerClose,

    // 初始化
    init: ctrl_init,

    // 工具（View 层也可能用到）
    isValidEmail: f_isValidEmail,
    formatPrice: f_formatPrice,
    getCartData: f_getCartData,

    // 常量
    PAYPAL_EMAIL: PAYPAL_EMAIL,
    WORKER_URL: WORKER_URL,
    INSIDER_DISCOUNT_RATE: INSIDER_DISCOUNT_RATE
  };

  // ============================================================
  // 调试接口
  // ============================================================

  window.SR_CART_CTRL = {
    getState: function() {
      var coupon = ctrl_getCoupon();
      return {
        customer: srPurchaseCustomer,
        products: srPurchaseProducts,
        coupon: coupon,
        addresses: ctrl_getAddresses(),
        defaultIdx: ctrl_getDefaultIdx()
      };
    }
  };

})();
